import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface H4Props extends ComponentPropsWithRef<"h4"> {
  blockPath: string;
  styles: Record<string, StyleValue>;
  text: string;
}

export const H4 = forwardRef<HTMLHeadingElement, H4Props>(
  ({ text, blockPath, styles, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <h4
        ref={ref}
        className={classNames(
          "wb-text-h4-color wb-text-h4 wb-font-h4 wb-leading-h4 wb-tracking-h4 wb-whitespace-pre-wrap",
          className,
        )}
        style={inlineStyles}
        data-testid="builder-heading"
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </h4>
    );
  },
);

H4.displayName = "H4";
